/**
 * Get the API base URL based on the environment
 * - In Capacitor (mobile): Use the server IP address for API calls
 * - In browser: Use relative URLs or localhost for development
 */
export const getApiBaseUrl = () => {
  // 1. Check for the environment variable first (Production/Cloudflare)
  if (process.env.REACT_APP_API_URL) {
    const apiUrl = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
    console.log('Using API URL from Environment:', apiUrl);
    return apiUrl;
  }

  // 2. Fallback for your specific production deployment to avoid "same origin" errors
  if (window.location.hostname.includes('pages.dev')) {
    console.log('Production detected, using samavedana.onrender.com fallback');
    return 'https://samavedana.onrender.com';
  }

  // 3. Local Development Detection
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // Use CRA/webpack dev-server proxy (package.json "proxy") to avoid CORS on any dev port
    return '';
  }

  // Runtime detection based on IP (mobile access)
  if (window.location.hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
    return `http://${window.location.hostname}:5000`;
  }

  return '';
};

export const API_BASE_URL = getApiBaseUrl();


